<div class="kt-chat__input">
  <div class="kt-chat__editor">
    <textarea
      style="height: 50px"
      [(ngModel)]="commentText"
      [disabled]="loading"
      placeholder="Type here..."
      atMention
      [atMentionItems]="staff"
    ></textarea>
  </div>
  <div class="kt-chat__toolbar">
    <div class="kt_chat__tools">
      <a href="javascript:;" [class.disabled]="loading" (click)="file.click()"
        ><i class="flaticon2-link"></i
      ></a>
      <a href="javascript:;" [class.disabled]="loading" (click)="photo.click()"
        ><i class="flaticon2-photograph"></i
      ></a>
      <!-- <a href=""><i class="flaticon2-photo-camera"></i></a> -->
    </div>
    <div class="kt_chat__actions">
      <button
        type="button"
        [disabled]="!commentText || commentText.trim() == '' || loading"
        class="btn btn-brand btn-md btn-upper btn-bold kt-chat__reply"
        (click)="addComment()"
        [ngClass]="{
          'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
        }"
      >
        <i class="fas fa-plus"></i> {{ 'MESSAGING.POST_COMMENT' | translate }}
      </button>
    </div>
  </div>
</div>

<div class="file-images">
  <span
    class="badge badge-default"
    *ngFor="let photo of imagesToUpload; let idx = index"
  >
    <img [src]="photo.previewSrc" width="35" alt="" />
    <label class="mr-1">{{ photo.file.name }}</label>
    <a href="javascript:;" (click)="imagesToUpload.splice(idx, 1)">
      <span
        class="kt-badge kt-badge--outline kt-badge--outline-2x kt-badge--danger"
      >
        <i class="fas fa-times text-danger"></i>
      </span>
    </a>
  </span>

  <span
    class="badge badge-default"
    *ngFor="let file of filesToUpload; let idx = index"
  >
    <label class="mr-1">{{ file.name }}</label>
    <a href="javascript:;" (click)="filesToUpload.splice(idx, 1)">
      <span
        class="kt-badge kt-badge--outline kt-badge--outline-2x kt-badge--danger"
      >
        <i class="fas fa-times text-danger"></i>
      </span>
    </a>
  </span>
</div>

<div class="form-group hidden">
  <input
    type="file"
    class="form-control"
    id="photos"
    multiple
    (change)="handleImageInput($event)"
    accept="image/x-png,image/gif,image/jpeg"
    #photo
  />
</div>

<div class="form-group hidden">
  <input
    type="file"
    class="form-control"
    id="files"
    multiple
    (change)="handleFileInput($event)"
    #file
  />
</div>
